import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDeleteMiscellaneousItems, useGetAllMiscellaneousItems } from '../hooks/hooks';
import "react-loading-skeleton/dist/skeleton.css";
import { showErrorToast, showSuccessToast } from '../components/common';
import AddMiscellaneousModal from './../modal/AddMiscellaneousModal'
import { debounce } from 'lodash';
import Header from '../components/Common/Header';
import NoDataFound from '../components/Common/NoDataFound';
import { DeleteIcon, EditIcon, GroupIcon, NDVasanI, NDVegetableI } from '../assets/icons/icon';
import SearchControls from '../components/Common/SearchControls';
import { usePagination } from '../hooks/usePagination';
import Pagination from '../components/Common/Pagination';
import { ButtonWithIcon } from '../components/Common/Buttons';
import TableSkeleton from '../components/Common/TableSkeleton';
import EntityListPage from '../components/Common/EntityListPage';

function MiscellaneousCopy() {
  const { t, i18n } = useTranslation();

  const filterFn = useCallback((list, searchText) => {
    if (!Array.isArray(list)) return [];

    const searchValue = searchText.trim().toLowerCase();
    if (!searchValue) return list;

    return list.filter((item) => {
      const nameEn = item?.name?.en?.toLowerCase?.() || "";
      const nameGu = item?.name?.gu?.toLowerCase?.() || "";
      return (
        nameEn.includes(searchValue) ||
        nameGu.includes(searchValue)
      );
    });
  }, []);

  // const onDeleteClose = (isDelete) => {
  //   if (isDelete) {
  //     handleDeleteMiscellaneousItems(isDeleteMiscellaneousItems);
  //   }
  //   setisOpenDelete(false)
  // }

  // const handleDeleteMiscellaneousItems = (item) => {
  //   deleteMiscellaneousItems(item, {
  //     onSuccess: async (res) => {
  //       refetch();
  //       showSuccessToast(res?.data?.message);
  //     },
  //     onError: (err) => {
  //       showErrorToast(err.response.data.error)
  //     },
  //   });
  // };

  // const handleClosePopup = async (isRefresh) => {
  //   setPopupOpen(false);
  //   setIsEdit(false);
  //   setIsEditItem(undefined);
  //   if (isRefresh) {
  //     refetch();
  //   }
  // }

  const getUnitTypes = (unitType) => {
    if (!unitType) return '-';
    switch (unitType.toLowerCase()) {
      case 'gram':
        return 'ગ્રામ (Gram)';
      case 'kgs':
        return 'કિગ્રા (KGS)';
      case 'liter':
        return 'લિટર (Liter)';
      case 'ml':
        return 'મિલીલીટર (ML)';
      case 'pieces':
        return 'નંગ (Pieces)';
      case 'per_person':
        return 'માણસો દીઠ (Per Person)';
      case 'roll':
        return 'રોલ (Roll)';
      case 'person':
        return 'માણસ (Person)';
      case 'event':
        return 'ઇવેન્ટ (Event)';
      default:
        return unitType;
    }
  }

  const getBaseQuantityUnitTypes = (unitType) => {
    if (!unitType) return 'person';
    switch (unitType.toLowerCase()) {
      case 'gram':
        return 'ગ્રામ (Gram)';
      case 'kgs':
        return 'કિગ્રા (KGS)';
      case 'liter':
        return 'લિટર (Liter)';
      case 'ml':
        return 'મિલીલીટર (ML)';
      case 'pieces':
        return 'નંગ (Pieces)';
      case 'per_person':
        return 'માણસો દીઠ (Per Person)';
      case 'roll':
        return 'રોલ (Roll)';
      case 'person':
        return 'માણસ (Person)';
      case 'event':
        return 'ઇવેન્ટ (Event)';
      default:
        return unitType;
    }
  }


  const getDisplayName = (item) => {
    const lang = (i18n?.language || 'en').toLowerCase();
    const isGu = lang.startsWith('gu');
    return (isGu ? item?.name?.gu : item?.name?.en) || item?.name?.en || item?.name?.gu || '';
  };

  const MiscellaneousCard = ({ item, index, onEdit, onDelete }) => (
    <div className="bg-white rounded-xl shadow-card border border-gray-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 p-6">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {getDisplayName(item)}
          </h3>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <NDVegetableI className='w-4 h-4 text-gray-500' />
              <span className="text-sm text-gray-600">
                {item.quantity} {item.unit ? getUnitTypes(item.unit) : ''}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <GroupIcon />
              <span className="text-sm text-gray-600">
                {item.baseQuantityFor} {getBaseQuantityUnitTypes(item.baseQuantityUnit)}
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} btnclass="p-[5px] text-green-600 hover:bg-green-50 rounded-md transition-all border border-green-300" iconClass="mr-0" onClick={onEdit} />
          <ButtonWithIcon title="Delete" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0" btnclass="p-[5px] text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );

  const TableRow = ({ item, index, startIndex, onEdit, onDelete }) => (
    <div
      className={`w-full flex py-4 font-medium text-sm text-gray-700 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200
          ${index % 2 === 0 ? "bg-gray-50/50" : "bg-white"}`}
    >
      <div className="w-[5%] pl-6 flex items-center font-medium text-gray-500">{startIndex + index + 1}</div>
      <div className="w-[30%] flex items-center pr-4">
        <div className="font-semibold text-gray-900 truncate" title={getDisplayName(item)}>{getDisplayName(item)}</div>
      </div>
      <div className="w-[20%] flex items-center pr-4">
        <div className="text-gray-700 truncate" title={`${item.quantity} ${item.unit || ''}`}>
          {item.quantity} {item.unit ? getUnitTypes(item.unit) : '-'}
        </div>
      </div>
      <div className="w-[25%] flex items-center pr-4">
        <div className="text-gray-700 truncate" title={`${item.baseQuantityFor} ${item.baseQuantityUnit || 'person'}`}>
          {item.baseQuantityFor} {getBaseQuantityUnitTypes(item.baseQuantityUnit)}
        </div>
      </div>
      <div className="w-[20%] flex items-center">
        <div className="flex items-center gap-2">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} btnclass="p-2 text-green-600 hover:bg-green-50 rounded-md transition-all border border-green-300" iconClass="mr-0" onClick={onEdit} />
          <ButtonWithIcon title="Edit" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0" btnclass="p-2 text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );


  const getNoDataDesc = useCallback((searchText) => {
    return searchText ? 'Try adjusting your search terms' : 'Get started by adding your first miscellaneous item';
  }, []);



  return (
    <>
      <EntityListPage
        title={t('MiscellaneousItems') || 'Miscellaneous Items'}
        subtitle={t('manage_your_miscellaneous_items') || 'Manage your miscellaneous items and products'}
        addButtonText={t('add_new_MiscellaneousItems')}
        searchPlaceholder={t('search_Miscellaneous_lbl') || 'Search miscellaneous items...'}

        fetchHook={useGetAllMiscellaneousItems}
        deleteHook={useDeleteMiscellaneousItems}
        filterFn={filterFn}

        tableColumns={[
          { key: "#", label: "#", className: "w-[5%]", width: 50 },
          { key: "name", label: t('MiscellaneousItems_name') || 'Name', className: "w-[30%]", width: 200 },
          { key: "quantity", label: t('Quantity') || 'Quantity', className: "w-[20%]", width: 150 },
          { key: "unit", label: t('BaseQuantityFor') || 'Base Quantity For', className: "w-[25%]", width: 150 },
          { key: "action", label: t('Action'), className: "w-[20%]", width: 80 },
        ]}

        TableRow={TableRow}
        Card={MiscellaneousCard}
        AddEditModal={AddMiscellaneousModal}

        getNoDataDesc={getNoDataDesc}
        emptyIcon={<NDVasanI />}
        emptyText="No miscellaneous items found"
        buttonText={'Add Miscellaneous Item'}
        deleteMsg={t('delete_MiscellaneousItems_confirmation_msg') || 'You want to delete this Miscellaneous Item?'}
      />
    </>
  )
}

export default MiscellaneousCopy
